import type { CustomerChosenOption } from "@shared-core/data/api-types";

// What the customer chose for an item line, as a compact definition list: "Paper: Silk paper 350gsm". The server
// decides which options a customer would recognise and words them (the dictionary's customer wording where
// written, else the technical label), so this only lays them out: label and value side by side, wrapping onto the
// next line on a phone. The basket, order and quote pages share it so a line reads the same on each. A line with
// no options (a service, or an item the dictionary can no longer read) draws nothing.
export function ChosenOptions({
  options,
}: {
  options: readonly CustomerChosenOption[];
}) {
  if (options.length === 0) return null;
  return (
    <dl
      data-testid="chosen-options"
      className="flex flex-wrap gap-x-4 gap-y-1 text-sm"
    >
      {options.map((option, index) => (
        <div key={`${index}-${option.group_label}`} className="flex gap-1">
          <dt className="text-muted-foreground after:content-[':']">
            {option.group_label}
          </dt>
          <dd className="min-w-0 break-words">{option.value_label}</dd>
        </div>
      ))}
    </dl>
  );
}
